export const packageList = [
  {
    name: 'qms',
    activeRule: ['qms'],
    preload: true,
  },
  {
    name: 'bids',
    activeRule: ['bids'],
  },
  {
    name: 'ims_supplier',
    activeRule: ['imsSupplier'],
  },
  {
    name: 'ims',
    activeRule: ['ims'],
    preload: true,
  },
  {
    name: 'ims_monitor',
    activeRule: ['ims-monitor'],
  },
  {
    name: 'ims_site',
    activeRule: ['ims-site'],
  },
  {
    name: 'ims_order',
    activeRule: ['ims-order'],
  },
  {
    name: 'ims_cost',
    activeRule: ['ims-cost'],
  },
  {
    name: 'ims_warehouse',
    activeRule: ['ims-warehouse'],
  },
  {
    name: 'ims_report',
    activeRule: ['ims-report'],
  }
]

export const remoteModuleConfig = {
  dev: ['qms', 'ims', 'bids', 'ims_supplier', 'ims_monitor', 'ims_site', 'ims_order', 'ims_cost', 'ims_warehouse', 'ims_report'],
  stg: ['qms', 'ims', 'bids', 'ims_supplier', 'ims_monitor', 'ims_site', 'ims_order', 'ims_cost', 'ims_warehouse', 'ims_report'],
  uat: ['qms', 'ims', 'bids', 'ims_supplier', 'ims_monitor', 'ims_site', 'ims_order', 'ims_cost', 'ims_warehouse', 'ims_report'],
  prd: ['qms', 'ims', 'bids', 'ims_supplier', 'ims_monitor', 'ims_site', 'ims_order', 'ims_cost', 'ims_warehouse', 'ims_report'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/ims/index.js